import { createTheme, Theme as MuiTheme } from '@mui/material';

import palette from './palette';

declare module '@emotion/react' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
  export interface Theme extends MuiTheme {}
}

export const theme = createTheme({
  palette: palette,
  typography: {
    fontFamily: 'Reddit Sans, sans-serif'
  }
});
